export default __webpack_public_path__ + "static/media/ally_s2.5207430c.png";